import React, { FC, useState } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { createHashHistory } from 'history';
import { Provider } from 'react-redux';
import { themeContext } from '@azgaz/azgaz-ui';
import createCarstockProvider, { utils } from '@lib/azgaz-ui/connect';

import { AppContext } from '@/apps/context';
import store from '../../store';
import outsideComponents from '../../outsideComponents';
import Cars from '../Cars';
import Car from '../Car';

import style from './style.module.scss';

const { ThemeProvider } = themeContext;

export const hashHistory = createHashHistory();

type AppCreatorProps = {
  filtersConfig: utils.PatchedFiltersConfig;
  azgazUiTheme: themeContext.ThemeType;
  components: typeof outsideComponents;
};

function appCreator({
  filtersConfig,
  azgazUiTheme,
  components,
}: AppCreatorProps) {
  const CarstockProvider = createCarstockProvider({
    carStockApi: ENV.carstockApi,
    filtersConfig,
    thumbId: 0,
    history: hashHistory,
    defaultPerPage: 21,
    // excludedQueryParamsGetValues: ['state'],
    excludedQueryParamsGetValues: ['group'],
  });

  Object.assign(outsideComponents, components);

  const App: FC = () => {
    const [price, setPrice] = useState<[number, number]>([0, 0]);

    return (
      <div className={style.app}>
        <Provider store={store}>
          <ThemeProvider value={azgazUiTheme}>
            <CarstockProvider>
              <AppContext.Provider
                value={{
                  price,
                  changePrice: v => setPrice(v),
                }}
              >
                <Router history={hashHistory}>
                  <Switch>
                    <Route path="/:id">
                      <Car />
                    </Route>
                    <Route path="/">
                      <Cars />
                    </Route>
                  </Switch>
                </Router>
              </AppContext.Provider>
            </CarstockProvider>
          </ThemeProvider>
        </Provider>
      </div>
    );
  };

  return App;
}

export default appCreator;
